import React, { FC, SVGProps } from 'react'

export const CameraSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={65}
      height={65}
      viewBox="0 0 65 65"
      fill="none"
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M47.223 14.699c-2.227 0-4.135-1.464-5.5-3.226a12.289 12.289 0 0 0-9.73-4.774c-2.366 0-4.595.674-6.489 1.85a12.37 12.37 0 0 0-3.24 2.924c-.768.992-1.71 1.89-2.783 2.485-.83.46-1.742.74-2.716.74h-.771c-5.89 0-10.667 4.777-10.667 10.667V46.7c0 5.89 4.776 10.666 10.667 10.666h32c5.89 0 10.666-4.776 10.666-10.666V25.365c0-5.89-4.776-10.666-10.666-10.666h-.771Zm.77 13.333c.69 0 1.321-.263 1.795-.694a2.666 2.666 0 1 0-4.461-1.973c0 .69.26 1.317.69 1.79.487.538 1.193.877 1.977.877Zm-16 18.667c5.891 0 10.668-4.776 10.668-10.667 0-5.89-4.777-10.667-10.667-10.667s-10.667 4.776-10.667 10.667c0 5.89 4.776 10.667 10.667 10.667Z"
        clipRule="evenodd"
      />
    </svg>
  )
}
